import React, { useEffect } from 'react';
import { X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
interface PrivacyModalProps {
  isOpen: boolean;
  onClose: () => void;
}
export function PrivacyModal({
  isOpen,
  onClose
}: PrivacyModalProps) {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [isOpen]);
  return <AnimatePresence data-id="element-204">
      {isOpen && <>
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} className="fixed inset-0 bg-black/70 backdrop-blur-sm z-50" onClick={onClose} data-id="element-205" />

          <motion.div initial={{
        opacity: 0,
        y: 40
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: 40
      }} transition={{
        duration: 0.3
      }} className="fixed inset-4 md:inset-10 lg:inset-x-auto lg:top-10 lg:bottom-10 lg:w-[800px] lg:mx-auto bg-navy-900 border border-teal-500/20 rounded-2xl z-50 flex flex-col overflow-hidden" data-id="element-206">
            <div className="flex items-center justify-between px-6 py-4 border-b border-teal-500/10 flex-shrink-0" data-id="element-207">
              <h2 className="text-xl font-display font-bold text-white" data-id="element-208">
                Política de Privacidad y Protección de Datos
              </h2>
              <button onClick={onClose} className="w-10 h-10 flex items-center justify-center rounded-lg hover:bg-navy-800 transition-colors text-gray-400 hover:text-white" aria-label="Cerrar" data-id="element-209">
                <X size={20} data-id="element-210" />
              </button>
            </div>

            <div className="flex-1 overflow-y-auto px-6 py-6" data-id="element-211">
              <div className="prose prose-invert max-w-none space-y-8 text-gray-300 leading-relaxed" data-id="element-212">
                <section data-id="element-213">
                  <h3 className="text-lg font-display font-semibold text-white mb-3" data-id="element-214">
                    1. INTRODUCCIÓN
                  </h3>
                  <p data-id="element-215">
                    En TruID valoramos y respetamos la privacidad de nuestros
                    usuarios. Esta Política de Privacidad describe cómo
                    recopilamos, utilizamos, almacenamos y protegemos los datos
                    personales que usted nos proporciona al utilizar nuestros
                    sitios web, APPs, terminales de autoatención u otros
                    sistemas o canales de comunicación.
                  </p>
                </section>

                <section data-id="element-216">
                  <h3 className="text-lg font-display font-semibold text-white mb-3" data-id="element-217">
                    2. RESPONSABLE DEL TRATAMIENTO
                  </h3>
                  <p data-id="element-218">
                    <span className="text-white font-medium" data-id="element-219">
                      Nombre de la entidad:
                    </span>{' '}
                    TruID es procesado por ZUMPAGOECUADOR SAS
                  </p>
                  <p className="mt-2" data-id="element-220">
                    <span className="text-white font-medium" data-id="element-221">
                      Correo electrónico de contacto:
                    </span>{' '}
                    <a href="mailto:protecciondatos@truid.org" className="text-teal-500 hover:text-teal-400 transition-colors" data-id="element-222">
                      protecciondatos@truid.org
                    </a>
                  </p>
                </section>

                <section data-id="element-223">
                  <h3 className="text-lg font-display font-semibold text-white mb-3" data-id="element-224">
                    3. DATOS PERSONALES QUE RECOPILAMOS
                  </h3>
                  <p className="mb-3" data-id="element-225">
                    Podemos recopilar los siguientes datos personales cuando
                    navegas o interactúas con nuestro sitio web u otros canales:
                  </p>
                  <ul className="list-disc list-inside space-y-2" data-id="element-226">
                    <li data-id="element-227">Nombres y apellidos</li>
                    <li data-id="element-228">Número de Cédula</li>
                    <li data-id="element-229">Correo electrónico</li>
                    <li data-id="element-230">Número de teléfono</li>
                    <li data-id="element-231">
                      Dirección IP y datos de navegación (cookies, ubicación,
                      tipo de navegador)
                    </li>
                    <li data-id="element-232">
                      Información proporcionada mediante formularios de contacto
                      o suscripción
                    </li>
                    <li data-id="element-233">
                      Información proporcionada mediante formularios o
                      requerimientos, con el objetivo de validación de
                      identidad, pertenencia, validación de acceso a otras
                      plataformas o tecnologías, u otros objetivos relacionados.
                    </li>
                  </ul>
                </section>

                <section data-id="element-234">
                  <h3 className="text-lg font-display font-semibold text-white mb-3" data-id="element-235">
                    4. FINALIDAD DEL TRATAMIENTO
                  </h3>
                  <p className="mb-3" data-id="element-236">
                    Recopilamos tus datos con las siguientes finalidades:
                  </p>
                  <ul className="list-disc list-inside space-y-2" data-id="element-237">
                    <li data-id="element-238">
                      Validación de identidad, pertenencia, acceso a
                      plataformas, validación de canales de comunicación u otros
                      relacionados.
                    </li>
                    <li data-id="element-239">
                      Gestionar la validación de identidad y acceso con terceras
                      plataformas interconectadas.
                    </li>
                    <li data-id="element-240">
                      Enviar información institucional, boletines, eventos,
                      productos y servicios
                    </li>
                    <li data-id="element-241">
                      Atender consultas o solicitudes realizadas a través de
                      formularios de contacto
                    </li>
                    <li data-id="element-242">Gestionar inscripciones a eventos o programas</li>
                    <li data-id="element-243">
                      Gestionar promociones, beneficios, sistemas de
                      fidelización y otras actividades de marketing
                    </li>
                    <li data-id="element-244">
                      Realizar análisis estadísticos de navegación (uso de
                      cookies)
                    </li>
                    <li data-id="element-245">Cumplir con obligaciones legales y regulatorias</li>
                  </ul>
                </section>

                <section data-id="element-246">
                  <h3 className="text-lg font-display font-semibold text-white mb-3" data-id="element-247">
                    5. LEGITIMACIÓN PARA EL TRATAMIENTO
                  </h3>
                  <p className="mb-3" data-id="element-248">
                    El tratamiento de tus datos se realiza con base en:
                  </p>
                  <ul className="list-disc list-inside space-y-2" data-id="element-249">
                    <li data-id="element-250">Tu consentimiento expreso</li>
                    <li data-id="element-251">
                      El interés legítimo de TruID para cumplir su misión
                      institucional
                    </li>
                    <li data-id="element-252">
                      El cumplimiento de obligaciones legales, según la
                      normativa ecuatoriana aplicable (Ley Orgánica de
                      Protección de Datos Personales – LOPDP)
                    </li>
                  </ul>
                </section>

                <section data-id="element-253">
                  <h3 className="text-lg font-display font-semibold text-white mb-3" data-id="element-254">
                    6. DESTINATARIOS DE LOS DATOS
                  </h3>
                  <p className="mb-3" data-id="element-255">
                    Tus datos personales no serán compartidos con terceros,
                    salvo que:
                  </p>
                  <ul className="list-disc list-inside space-y-2" data-id="element-256">
                    <li data-id="element-257">Tengamos tu consentimiento previo</li>
                    <li data-id="element-258">
                      Sea requerido por autoridad competente conforme a la ley
                    </li>
                    <li data-id="element-259">
                      Se usen herramientas tecnológicas de terceros (por
                      ejemplo, para envío de newsletters, CRM o formularios o
                      validación de accesos) con contratos que garantizan la
                      protección de tus datos
                    </li>
                  </ul>
                </section>

                <section data-id="element-260">
                  <h3 className="text-lg font-display font-semibold text-white mb-3" data-id="element-261">
                    7. DERECHOS DEL TITULAR DE LOS DATOS
                  </h3>
                  <p className="mb-3" data-id="element-262">Tienes derecho a:</p>
                  <ul className="list-disc list-inside space-y-2" data-id="element-263">
                    <li data-id="element-264">Acceder a tus datos personales</li>
                    <li data-id="element-265">Rectificar datos inexactos o incompletos</li>
                    <li data-id="element-266">Eliminar tus datos (cuando proceda)</li>
                    <li data-id="element-267">Oponerte al tratamiento</li>
                    <li data-id="element-268">Solicitar la portabilidad de tus datos</li>
                    <li data-id="element-269">Revocar el consentimiento en cualquier momento</li>
                  </ul>
                  <p className="mt-3" data-id="element-270">
                    Puedes ejercer estos derechos escribiéndonos a{' '}
                    <a href="mailto:protecciondatos@truid.org" className="text-teal-500 hover:text-teal-400 transition-colors font-medium" data-id="element-271">
                      protecciondatos@truid.org
                    </a>
                  </p>
                </section>

                <section data-id="element-272">
                  <h3 className="text-lg font-display font-semibold text-white mb-3" data-id="element-273">
                    8. USO DE COOKIES
                  </h3>
                  <p data-id="element-274">
                    Nuestros sitios utilizan cookies propias y de terceros para
                    mejorar la experiencia de navegación y análisis del tráfico.
                    Puedes aceptar, configurar o rechazar el uso de cookies
                    desde el banner de consentimiento al ingresar al sitio.
                  </p>
                </section>

                <section data-id="element-275">
                  <h3 className="text-lg font-display font-semibold text-white mb-3" data-id="element-276">
                    9. SEGURIDAD DE LA INFORMACIÓN
                  </h3>
                  <p data-id="element-277">
                    TruID aplica medidas de seguridad técnicas y organizativas
                    adecuadas para proteger tus datos personales contra accesos
                    no autorizados, pérdida, destrucción o alteración.
                  </p>
                </section>

                <section data-id="element-278">
                  <h3 className="text-lg font-display font-semibold text-white mb-3" data-id="element-279">
                    10. CONSERVACIÓN DE LOS DATOS
                  </h3>
                  <p data-id="element-280">
                    Tus datos serán conservados solo durante el tiempo necesario
                    para cumplir con la finalidad para la que fueron recopilados
                    o mientras exista una relación institucional o contractual.
                    Posteriormente serán eliminados o anonimizados, según
                    corresponda.
                  </p>
                </section>

                <section data-id="element-281">
                  <h3 className="text-lg font-display font-semibold text-white mb-3" data-id="element-282">
                    11. CAMBIOS A ESTA POLÍTICA
                  </h3>
                  <p data-id="element-283">
                    Nos reservamos el derecho de modificar esta Política de
                    Privacidad en cualquier momento. Cualquier cambio será
                    publicado con la fecha de actualización correspondiente.
                  </p>
                </section>

                <section data-id="element-284">
                  <h3 className="text-lg font-display font-semibold text-white mb-3" data-id="element-285">
                    12. AUTORIDAD DE CONTROL
                  </h3>
                  <p data-id="element-286">
                    Si consideras que tus derechos no han sido respetados,
                    puedes presentar un reclamo ante la Autoridad de Protección
                    de Datos Personales de Ecuador, la Superintendencia de
                    Protección de Datos Personales.
                  </p>
                </section>

                <section data-id="element-287">
                  <h3 className="text-lg font-display font-semibold text-white mb-3" data-id="element-288">
                    13. VIGENCIA
                  </h3>
                  <p data-id="element-289">
                    La vigencia de estas Políticas de Privacidad y Protección de
                    Datos es desde el 21 de noviembre de 2025 y permanecerá
                    vigente hasta que exista una nueva versión que la reemplace.
                  </p>
                </section>
              </div>
            </div>
          </motion.div>
        </>}
    </AnimatePresence>;
}